import $ from 'jquery';
var initial = '';
var values = {};

$(document).on('click', 'input:checkbox[name="radio"]', function () {
  $(this).parent().siblings().find('input:checkbox[name="radio"]').prop('checked', false);
});

$(document).on('click', '#return', function () {
  var form_name = $(this).attr('name');
  $('.' + form_name)
    .hide()
    .html(initial)
    .fadeIn('slow');
  Object.keys(values).forEach(function (key) {
    if (key == 'checkboxes') {
      $('.' + form_name + ' input[type="checkbox"][value="' + this[key] + '"]').prop('checked', true);
    } else if (key == 'radio') {
      $('.' + form_name + ' input[type="radio"][value="' + this[key] + '"]').prop('checked', true);
    } else {
      $('.' + form_name + ' #' + key).val(this[key]);
    }
  }, values);
});

$(document).on('click', '#confirm', function (element) {
  var form_name = $(this).attr('name');
  const status = validateInputs(form_name);
  console.log(status);
  if (!status) {
    initial = $('.' + form_name).html();
    var text = confirmInputs(form_name);
    $('.' + form_name)
      .hide()
      .html(text)
      .fadeIn('slow');
  }
});

function validateInputs(form_name) {
  var notEntered = [];
  var required = '';
  if (form_name == 'customer-form') {
    required = {
      name: '氏名',
      email: 'メール',
      tel: '電話番号',
      checkboxes: 'お問い合わせ内容',
      body: 'お問い合わせ',
      privacy: '個人情報の取り扱いに同意'
    };
  } else if (form_name == 'company-form') {
    required = {
      company: '事務所名',
      name: '担当者名',
      email: 'メール',
      // tel: '電話番号',
      patient: '氏名',
      sex: '性別',
      address: '住所',
      checkboxes: '特別な医療',
      // etc: '特別な医療（その他）',
      body: '詳細',
      privacy: '個人情報の取り扱いに同意'
    };
  } else if (form_name == 'recruit-form') {
    required = {
      name: '氏名',
      name_kana: '氏名（ふりがな）',
      address: '現住所',
      address_kana: '現住所（ふりがな）',
      email: '連絡先メールアドレス',
      tel: '連絡先携帯電話',
      radio: '求人種別',
      education_year_1: '年度',
      education_name_1: '学校名',
      // work_year_1: '年度',
      // work_company_1: '職歴',
      // certification_year_1: '年度',
      // certification_name_1: '資格名',
      pr: '志望動機',
      privacy: '個人情報の取り扱いに同意'
    };
  }

  Object.keys(required).forEach(function (key) {
    var name = this[key];
    console.log(key, this[key]);
    if (key == 'checkboxes' || key == 'privacy' || key == 'sex') {
      var array = [];
      $('.' + form_name + ' #' + key + '[type="checkbox"]:checked').each(function () {
        array.push($(this).val());
      });
      $('.' + form_name + ' #' + key)
        .parent()
        .parent()
        .find('span')
        .empty();
      console.log(array);
      if (array.length == 0) {
        $('.' + form_name + ' #' + key)
          .parent()
          .parent()
          .find('span')
          .append(name + 'を入力ください');
        notEntered.push(key);
      }
    } else if (key == 'radio') {
      var array = [];
      $('.' + form_name + ' input[type="radio"]:checked').each(function () {
        array.push($(this).val());
      });
      $('.' + form_name + ' #' + key)
        .parent()
        .parent()
        .find('span')
        .empty();
      if (array.length == 0) {
        $('.' + form_name + ' #' + key)
          .parent()
          .parent()
          .find('span')
          .append(name + 'を入力ください');
        notEntered.push(key);
      }
    } else if (key == 'purpose' || key == 'time' || key == 'education_type_1') {
      var value = $('.' + form_name + ' #' + key + ' option:selected').val();
      $('.' + form_name + ' #' + key)
        .parent()
        .find('span')
        .empty();
      if (value == 'none') {
        $('.' + form_name + ' #' + key)
          .parent()
          .find('span')
          .append(name + 'を入力ください');
        notEntered.push(key);
      }
    } else if (key == 'email') {
      $('.' + form_name + ' #' + key)
        .nextAll('span')
        .empty();
      var value = $('.' + form_name + ' #' + key).val();
      var reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
      if (!reg.test(value)) {
        $('.' + form_name + ' #' + key)
          .nextAll('span')
          .text(name + 'を正しく入力ください');
        notEntered.push(key);
      }
    } else if (key == 'tel') {
      $('.' + form_name + ' #' + key)
        .nextAll('span')
        .empty();
      var value = $('.' + form_name + ' #' + key)
        .val()
        .replace(/[━.*‐.*―.*－.*\-.*ー.*\-]/gi, '');
      var reg = /^(0[5-9]0[0-9]{8}|0[1-9][1-9][0-9]{7})$/;
      if (!reg.test(value)) {
        $('.' + form_name + ' #' + key)
          .nextAll('span')
          .text(name + 'を正しく入力ください');
        notEntered.push(key);
      }
    } else {
      $('.' + form_name + ' #' + key)
        .nextAll('span.form-section__error')
        .empty();
      $('.' + form_name + ' #' + key)
        .parent()
        .nextAll('span.form-section__error')
        .empty();
      var value = $('.' + form_name + ' #' + key).val();
      if (!value) {
        if ($('.' + form_name + ' #' + key).nextAll('span.form-section__error').length > 0) {
          $('.' + form_name + ' #' + key)
            .nextAll('span.form-section__error')
            .text(name + 'を入力ください');
        } else {
          $('.' + form_name + ' #' + key)
            .parent()
            .nextAll('span.form-section__error')
            .text(name + 'を入力ください');
        }
        notEntered.push(key);
      }
    }
  }, required);
  console.log('notEntered', notEntered);
  return notEntered.length > 0;
}

function confirmInputs(form_name) {
  var text = '';
  text += '<div class="form-item">' + '\n';
  var inputs = '';
  if (form_name == 'customer-form') {
    inputs = {
      name: '氏名',
      email: 'メール',
      tel: 'お電話番号',
      checkboxes: 'お問い合わせ内容',
      body: 'お問い合わせ'
    };
  } else if (form_name == 'company-form') {
    inputs = {
      company: '事務所名',
      name: '担当者名',
      email: 'メール',
      tel: '電話番号',
      patient: '氏名',
      sex: '性別',
      address: '住所',
      checkboxes: '特別な医療',
      etc: '特別な医療（その他）',
      body: '詳細'
    };
  } else if (form_name == 'recruit-form') {
    inputs = {
      name: '氏名',
      name_kana: '氏名（ふりがな）',
      address: '現住所',
      address_kana: '現住所（ふりがな）',
      email: 'メール',
      tel: '電話番号',
      radio: '求人種別',
      education_year_1: '年度①',
      education_name_1: '名称①',
      education_facility_1: '学校①',
      education_type_1: '入卒業①',
      education_year_2: '年度②',
      education_name_2: '名称②',
      education_facility_2: '学校②',
      education_type_2: '入卒業②',
      education_major_2: '学部・学科②',
      education_year_3: '年度③',
      education_name_3: '名称③',
      education_facility_3: '学校③',
      education_type_3: '入卒業③',
      education_major_3: '学部・学科③',
      work_year_1: '年度①',
      work_company_1: '職歴①',
      work_year_2: '年度②',
      work_company_2: '職歴②',
      work_year_3: '年度③',
      work_company_3: '職歴③',
      certification_year_1: '年度①',
      certification_name_1: '資格名①',
      certification_year_2: '年度②',
      certification_name_2: '資格名②',
      certification_year_3: '年度③',
      certification_name_3: '資格名③',
      pr: '志望動機'
    };
  }
  Object.keys(inputs).forEach(function (key) {
    var name = this[key];
    if (key == 'checkboxes' || key == 'sex') {
      var checked = '';
      var checkboxes = [];
      console.log(key);
      $('.' + form_name + ' #' + key + ':checked').each(function () {
        //値を取得
        console.log(key);
        console.log($(this));
        checked += $(this).val() + ' ';
        checkboxes.push($(this).val());
      });
      text += '<div class="form-item__key">' + name + '</div>' + '\n';
      text += '<div class="form-item__value">' + checked + '</div>' + '\n';
      values[key] = checkboxes;
      console.log(checkboxes);
    } else if (key == 'purpose' || key == 'time') {
      var value = $('.' + form_name + ' #' + key + ' option:selected').val();
      values[key] = value;
      text += '<div class="form-item__key">' + name + '</div>' + '\n';
      text += '<div class="form-item__value">' + value + '</div>' + '\n';
    } else {
      var value = $('.' + form_name + ' #' + key).val();
      values[key] = value;
      text += '<div class="form-item__key">' + name + '</div>' + '\n';
      text += '<div class="form-item__value">' + value + '</div>' + '\n';
    }
  }, inputs);
  console.log(values);
  text += '</div>' + '\n';
  text += '<div class="form-section__buttons">' + '\n';
  text +=
    '<button class="button" id="submit" name="' +
    form_name +
    '" onclick="gtag("event", "click", {"event_category": "customer" });" href="">送信する</button>';
  text +=
    '<input class="button button--return" id="return" type="button" href="" name="' + form_name + '" value="戻る">';
  text += '</div>' + '\n';
  return text;
}

$(document).on('click', '#submit', function () {
  var form_name = $(this).attr('name');
  var data = setData(form_name);
  $.ajax({
    url: '../wp-admin/admin-ajax.php',
    type: 'POST',
    data: data
  })
    .done(function (data) {
      var message = '';
      message += '<div class="sub-heading__wrapper">' + '\n';
      message += '<h2 class="sub-heading">お問い合わせを受け付けました。</h3>' + '\n';
      message += '</div>' + '\n';
      message += '<div class="p-single-content">' + '\n';
      message += '<p>' + '\n';
      message += 'お問い合わせいただきました内容を確認後、担当者より改めてご連絡いたします。' + '\n';
      message += '</p>' + '\n';
      message += '</div>' + '\n';
      $('.' + form_name)
        .hide()
        .html(message)
        .fadeIn('slow');
    })
    .fail(function (XMLHttpRequest, textStatus, errorThrown) {
      var message = '';
      message += '<div class="sub-heading__wrapper">' + '\n';
      message += '<h2 class="sub-heading">メッセージの送信に失敗しました。</h3>' + '\n';
      message += '</div>' + '\n';
      message += '<div class="p-single-content">' + '\n';
      message += '<p>' + '\n';
      message += '恐れ入りますが、時間をおいてもう一度お試しください。' + '\n';
      message += '</p>' + '\n';
      message += '</div>' + '\n';
      $('.' + form_name)
        .hide()
        .html(message)
        .fadeIn('slow');
      console.log(errorThrown.message);
    });
  $('body,html').animate({ scrollTop: 0 }, 500, 'swing');
});

function setData(form_name) {
  var data = {};
  if (form_name == 'customer-form') {
    data = {
      action: 'contacts_form',
      フォーム: '店舗見学・学生実習について',
      氏名: values.name,
      メール: values.email,
      電話番号: values.tel,
      お問い合わせ内容: values.checkboxes,
      お問い合わせ: values.body
    };
  } else if (form_name == 'company-form') {
    data = {
      action: 'contacts_form',
      フォーム: '居宅療養管理指導のご依頼',
      事務所名: values.company,
      担当者名: values.name,
      メール: values.email,
      電話番号: values.tel,
      氏名: values.patient,
      性別: values.sex[0],
      住所: values.address,
      特別な医療: values.checkboxes,
      その他: values.etc,
      詳細: values.body
    };
  } else if (form_name == 'recruit-form') {
    data = {
      action: 'contacts_form',
      フォーム: '求人に応募',
      氏名: values.name,
      氏名ふりがな: values.name_kana,
      住所: values.address,
      住所ふりがな: values.address_kana,
      メール: values.email,
      電話番号: values.tel,
      求人種別: values.radio,
      学歴年１: values.education_year_1,
      名称１: values.education_name_1,
      学校１: values.education_facility_1,
      入卒業１: values.education_type_1,
      学歴年２: values.education_year_2,
      名称２: values.education_name_2,
      学校２: values.education_facility_2,
      入卒業２: values.education_type_2,
      学科２: values.education_major_2,
      学歴年３: values.education_year_3,
      名称３: values.education_name_3,
      学校３: values.education_facility_3,
      入卒業３: values.education_type_3,
      学科３: values.education_major_3,
      職歴年１: values.work_year_1,
      職歴１: values.work_company_1,
      職歴年２: values.work_year_2,
      職歴２: values.work_company_2,
      職歴年３: values.work_year_3,
      職歴３: values.work_company_3,
      資格年１: values.certification_year_1,
      資格名１: values.certification_name_1,
      資格年２: values.certification_year_2,
      資格名２: values.certification_name_2,
      資格年３: values.certification_year_3,
      資格名３: values.certification_name_3,
      志望動機: values.pr
    };
  }
  return data;
}
